import React from 'react';
import { useLocation } from 'react-router-dom';

const MobileStatement = () => {
  const location = useLocation();
  const statement = location.state?.statement;

  if (!statement) return <p style={{ textAlign: 'center', fontWeight: 700 }}>No statement selected.</p>;

  return (
    <div>
      <h2 style={{ fontSize: '18px', fontWeight: 700, color: '#094268', marginBottom: '10px' }}>{statement.respondent}</h2>
      <div style={{ marginBottom: '8px' }}>
        {statement.age ? `Age ${statement.age}, ` : ''}{statement.gender}
      </div>
      <div style={{ marginBottom: '8px', color: statement.inconsistentWithFIR === 'Yes' ? '#E53935' : '#4CAF50' }}>
        Inconsistent with FIR: {statement.inconsistentWithFIR || 'No'}
      </div>

      {statement.statementSummary && (
        <div style={{ marginTop: '12px' }}>
          <b>Summary</b>
          <p style={{ textAlign: 'justify' }}>{statement.statementSummary}</p>
        </div>
      )}

      {statement.inconsistentWithFIRExplanation && (
        <div style={{ marginTop: '12px' }}>
          <b>Inconsistency Explanation</b>
          <p style={{ textAlign: 'justify' }}>{statement.inconsistentWithFIRExplanation}</p>
        </div>
      )}

      {statement.crucialOmissions && (
        <div style={{ marginTop: '12px' }}>
          <b>Crucial Omissions</b>
          <p style={{ textAlign: 'justify' }}>{statement.crucialOmissions}</p>
        </div>
      )}

      {statement.text && (
        <div style={{ marginTop: '12px' }}>
          <b>Full Statement</b>
          <p style={{ textAlign: 'justify', whiteSpace: 'pre-wrap' }}>{statement.text}</p>
        </div>
      )}
    </div>
  );
};

export default MobileStatement;
